import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  // eslint-disable-next-line no-console
  console.error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

// The Supabase project is shared across all CloudDodo apps. DodoBooks
// scopes its data via the `dodobooks_*` table prefix, with RLS keyed on
// dodobooks_is_member(org_id) so users only see rows for orgs they belong to.
export const supabase = createClient<Database>(url!, key!, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'dodobooks-auth',
  },
});
